import { specialCardLetters } from "../cards";

interface IDTWinItem {
	dragon: string;
	tiger: string;
}

function getDragonVal(winItem: IDTWinItem): number {
	return winItem.dragon[0] in specialCardLetters ?
		specialCardLetters[winItem.dragon[0]] :
		isNaN(+winItem.dragon[0]) ? 0 :
			+winItem.dragon[0];
}

function getTigerVal(winItem: IDTWinItem): number {
	return winItem.tiger[0] in specialCardLetters ?
		specialCardLetters[winItem.tiger[0]] :
		isNaN(+winItem.tiger[0]) ? 0 :
			+winItem.tiger[0];
}

export {
	getDragonVal,
	getTigerVal
}
